exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-ugm-white[data-v-31cc48f3]{background:#fff!important;color:#252c5f!important;border:1px solid #fff!important;border-radius:6px;padding:5px 14px;font-size:.8rem;font-weight:600;cursor:pointer;transition:opacity .2s}.btn-ugm-white[data-v-31cc48f3]:hover{opacity:.85}.btn-ugm-gold[data-v-31cc48f3]{background:#cb9700!important;color:#fff!important;border:1px solid #cb9700!important;border-radius:6px;padding:5px 14px;font-size:.8rem;font-weight:600;cursor:pointer;transition:opacity .2s}.btn-ugm-gold[data-v-31cc48f3]:hover{opacity:.88}", ""]);

// exports
